import React, {FC, ReactNode} from 'react';
import {Col, Row, Typography} from 'antd';
import {Observer} from 'mobx-react';
import styles from './MainTitle.module.less';

interface MainTitleProps {
    title: string;
    items: ReactNode[];
}

export const MainTitle: FC<MainTitleProps> = ({title, items}) => {
    return (
        <div className="main-heading">
            <Row align="middle" className="width-100">
                <Col className={styles['main-title-wrap']}>
                    <Observer
                        render={() => <Typography.Title className="main-title truncate-100">{title}</Typography.Title>}
                    />
                </Col>
                <Col>
                    <Row gutter={10} className="list-like" align="middle">
                        {items.map((item, i) => (
                            <Col key={i}>
                                <div className="item">{item}</div>
                            </Col>
                        ))}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};
